import { useState, useEffect } from 'react'
import { mathOperations } from './mathOperations'
import SFXS from '../../assets/audios/audios'
// import {
//   checkOnlyDot,
//   checkForEmpty,
//   checkStartWithZeros,
// } from 'components/input/helpers/checkerFunctions'

type operations = false | 'plus' | 'minus' | '1/2' | '2x' | '5x'

export default function useStakeOperations(
  stake: string,
  min: string,
  max: string,
  precision: number,
  audio?: any,
  handleNotification?: any,
  currency?: string,
  isZero?: boolean,
) {
  const { divideSFX, multiplySFX } = SFXS
  const [finalStake, setfinalStake] = useState<string>(stake)
  const [inputStake, setinputStake] = useState<string>(stake)

  const [operation, setoperation] = useState<operations>(false)
  // const max = '100' // todo dynamic
  // const min = '0.10' // todo dynamic
  // const toFix = 2

  let interval: any = null
  let soundInterval: any = null
  let timeout: any = null

  const vol = parseFloat(audio.volume)

  multiplySFX.volume = vol
  divideSFX.volume = vol

  useEffect(() => {
    if (operation) {
      setfinalStake(
        mathOperations(
          stake,
          operation,
          precision,
          max,
          min,
          handleNotification,
          currency,
          isZero,
        ),
      )
      setinputStake(
        mathOperations(
          stake,
          operation,
          precision,
          max,
          min,
          handleNotification,
          currency,
          isZero,
        ),
      )
    }
    if (operation === 'plus' || operation === 'minus') {
      timeout = setTimeout(() => {
        soundInterval = setInterval(() => {
          if (operation === 'plus') {
            multiplySFX.currentTime = 0
            audio.sound && multiplySFX.play()
          } else {
            divideSFX.currentTime = 0
            audio.sound && divideSFX.play()
          }
        }, 100)
        interval = setInterval(() => {
          setfinalStake(s =>
            mathOperations(
              s,
              operation,
              precision,
              max,
              min,
              handleNotification,
              currency,
              isZero,
            ),
          )
          setinputStake(s =>
            mathOperations(
              s,
              operation,
              precision,
              max,
              min,
              handleNotification,
              currency,
              isZero,
            ),
          )
        }, 80)
      }, 200)
    }
    return () => {
      clearInterval(interval)
      clearInterval(soundInterval)
      clearTimeout(timeout)
    }
  }, [
    operation,
    precision,
    max,
    min,
    audio.sound,
    divideSFX,
    multiplySFX,
    handleNotification,
  ])

  const makeMathOperation = (g: operations): any => setoperation(g)

  // aq unda daematos checkebi
  // const inputfinalStake = (str: any): any => {
  //   setfinalStake(str)
  // }

  return [
    finalStake,
    makeMathOperation,
    setfinalStake,
    inputStake,
    setinputStake,
  ] as const
}
